require('../bootstrap');
require('../libs/bootstrap.bundle');

require('../revered/components/routes');
require('moment');
require('../libs/revered-helpers');
require('fancybox');
window.Swiper = require('swiper').default;

window.swal = require('sweetalert2');

require('select2');
window.select2_en = require('select2/src/js/select2/i18n/en');
window.select2_ru = require('select2/src/js/select2/i18n/ru');

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeRu from 'air-datepicker/locale/ru';
window.AirDatepicker = AirDatepicker;
window.localeRu = localeRu;
